import useViewMode from 'client/services/hooks/use-view-mode';
import {ViewMode} from 'client/services/hooks/use-view-mode/types';

import {Autotask} from 'client/models/autotask/types';
import {Client} from 'client/models/client/types';

const getOperationPathFlowAccess = (viewMode: ViewMode, client?: Client, autotask?: Autotask) => {
  if (viewMode.on) {
    return viewMode.settings.operationPathFlow;
  }

  return autotask?.editor_v2 ?? client?.editor_v2 ?? viewMode.settings.operationPathFlow;
};

export default (params: {client?: Client; autotask?: Autotask} = {}): Record<string, boolean> => {
  const {client, autotask} = params;
  const {viewMode} = useViewMode();

  return {
    operationPathFlow: getOperationPathFlowAccess(viewMode, client, autotask),
    operationDesignFlow: getOperationPathFlowAccess(viewMode, client, autotask),
  };
};
